import React, { useState } from "react";
import Button, { ButtonType } from "../Assets/Button";
import toast from "react-hot-toast";

interface TaskManagerTimeInputModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (time: string) => void;
}

const TaskManagerTimeInputModal: React.FC<TaskManagerTimeInputModalProps> = ({
  isOpen,
  onClose,
  onSubmit,
}) => {
  const [time, setTime] = useState("");

  const handleSubmit = () => {
    if (!/^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/.test(time)) {
      toast.error("Please enter time in HH:MM format");
      return;
    }
    onSubmit(time);
    setTime("");
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white p-6 rounded-lg shadow-lg w-96">
        <h2 className="text-sm font-semibold mb-4">Enter Approximate Time</h2>
        <div className="mb-4">
          <label className="block text-xs font-medium text-gray-700 mb-1">
            Time (HH:MM)
          </label>
          <input
            type="text"
            placeholder="e.g., 02:30"
            value={time}
            onChange={(e) => setTime(e.target.value)}
            className="w-full p-2 border border-gray-300 rounded-md text-xs"
          />
        </div>
        <div className="flex justify-end space-x-2">
          <Button
            type={ButtonType.Cancel}
            onClick={onClose}
            className="text-xs"
          >
            Cancel
          </Button>
          <Button
            type={ButtonType.Submit}
            onClick={handleSubmit}
            className="text-xs"
          >
            Completed
          </Button>
        </div>
      </div>
    </div>
  );
};

export default TaskManagerTimeInputModal;
